<template>
  
  <div>
    

    

  <div class="signup-wrapper">

        
    <v-container class="form-container">
      <v-card class="signup-card" elevation="4">
        <!-- En-tête -->
        <div class="header">
        <h1 class="pettycash-logo">
          <div style="color: #00479b; display: inline-block;">Petty</div>
          <div style="color: #009688; display: inline-block; margin-left: 4px;">Cash</div>
        </h1>
        <h2 class="subtitle" style="font-weight: 700;">Create a Business Account</h2>
        <div class="divider"></div>
        

      </div>
    
        <v-form @submit.prevent="submitForm">
   


    <!-- Champ Nom d'utilisateur -->
    <div class="name-fields">
      <v-layout row>
        <v-flex xs2 sm1>
          <i class="teal--text fas fa-user-circle fa-2x mt-2"></i>
        </v-flex>
        <v-flex xs10 sm10>
          <v-text-field
            v-model="form.username"
            label="Username"
            :rules="usernameRules"
            outlined
            dense
          ></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-btn 
            @click.stop="$store.commit('activateDialog', true); username_help = true; getSignUpFieldHelp()"
            flat fab small outline color="black" 
            class="my-3" 
            style="height:20px; width: 20px"
          >
            <i class="fas fa-question small-question"></i>
          </v-btn>
        </v-flex>
      </v-layout>
    </div>

    <!-- Champ Email -->
    <div class="name-fields">
      <v-layout row>
        <v-flex xs2 sm1>
          <i class="teal--text fas fa-envelope fa-2x mt-2"></i>
        </v-flex>
        <v-flex xs10 sm10>
          <v-text-field
            v-model="form.email"
            label="Email address"
            :rules="emailRules"
            outlined
            dense
          ></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-btn 
            @click.stop="$store.commit('activateDialog', true); email_help = true; getSignUpFieldHelp()"
            flat fab small outline color="black" 
            class="my-3" 
            style="height:20px; width: 20px"
          >
            <i class="fas fa-question small-question"></i>
          </v-btn>
        </v-flex>
      </v-layout> 
    </div>



    <!-- Champ Téléphone -->
    <div class="name-fields">
      <v-layout row>
      <v-flex xs2 sm1>
          <i class="teal--text fas fa-phone fa-2x mt-2"> </i>                            
      </v-flex>
      <v-flex xs10 sm10>
        
          <input @click="clearPhoneField()" id="phone" required type="tel" value="Enter Phone Number" v-model="phone_number" ref="phone_number" name="phone" class="py-2 my-2" style="width: 100%!important; border-bottom: 1px grey solid" />
      </v-flex>
      <v-flex xs1 >
          <v-btn @click.stop="$store.commit('activateDialog', true); phone_number_help = true; getSignUpFieldHelp()" flat fab small outline color="black" class="my-3" style="height:20px; width: 20px" >
              <i class="fas fa-question"> </i>                            
          </v-btn>
      </v-flex>
  </v-layout>

    </div>

    <!-- Champ Mot de passe -->
    <div class="name-fields">
      <v-layout row>
        <v-flex xs2 sm1>
          <i class="teal--text fas fa-lock fa-2x mt-2"></i>
        </v-flex>
        <v-flex xs10 sm10>
          <v-text-field
          id="securityKey"
          :append-icon="e1 ? 'visibility_off' : 'visibility'"
          @click:append="() => (e1 = !e1)"
          :type="e1 ? 'text' : 'password'"
            v-model="form.password"
            label="Password"
            :rules="passwordRules"
            outlined
            dense
                            
          ></v-text-field>
        </v-flex>
        <v-flex xs1>
          <v-btn 
            @click.stop="$store.commit('activateDialog', true); password_help = true; getSignUpFieldHelp()"
            flat fab small outline color="black" 
            class="my-3" 
            style="height:20px; width: 20px"
          >
            <i class="fas fa-question small-question"></i>
          </v-btn>
        </v-flex>
      </v-layout>
    </div>

    <!-- Champ Référence (nouveau système) -->
    <div class="name-fields">
      <ReferralField
        v-model="referralCode"
        :state="referralState"
        :ownerName="referralOwnerName"
        :locked="referralLocked"
        @input="onReferralInput"
      />
    </div>

    <v-btn
      block
      @click="submitForm"
      color="teal"
      class="signup-btn"
      type="submit"
    >
      Next
    </v-btn>
  </v-form>

        <!-- Lien de connexion -->
        <div class="login-link">
          Already have an account? <a href="/login">Log In</a>
        </div>
      </v-card>
    </v-container>
    <v-dialog width="500px" v-model="showPayment"> 
  <v-card> 
    <v-card-title class="headline primary darken-2 white--text" primary-title>
      Confirm Deposit
    </v-card-title> 
    
    <v-card-text class="pa-4">
      <div class="name-fields">
        <div class="name-fields">
          <v-layout row>
              <v-flex xs2 sm1>
                <i class="teal--text fas fa-phone fa-2x mt-2"></i>
              </v-flex>
              <v-flex xs10 sm10>
                <input 
                  id="transactionPhone" 
                  type="tel" 
                  @click="clearTransactionPhoneField()" 
                  class="py-2 my-2" 
                  style="width: 100%!important; border-bottom: 1px grey solid" 
                />
              </v-flex>
              <v-flex xs1>
                <v-btn 
                  @click.stop="$store.commit('activateDialog', true); phone_number_help = true; getSignUpFieldHelp()"
                  flat fab small outline color="black" 
                  class="my-3" 
                  style="height:20px; width: 20px"
                >
                  <i class="fas fa-question"></i>
                </v-btn>
              </v-flex>
            </v-layout>
        </div>        </div>
      <v-layout row wrap class="mb-4">
        <v-flex xs6 class="text-center">
          <v-card 
            @click="selectOperator('MTN')"
            :class="{ 'selected-operator': paymentMethod === 'MTN' }"
            class="pa-2 operator-card"
          >
            <v-img
              :src="require('@/assets/mtn-mobile-money-logo.png')"
              contain height="60"
            ></v-img>
          </v-card>
        </v-flex>
        
        <v-flex xs6 class="text-center">
          <v-card 
            @click="selectOperator('OM')"
            :class="{ 'selected-operator': paymentMethod === 'OM' }"
            class="pa-2 operator-card"
          >
            <v-img
              :src="require('@/assets/om.png')"
              contain height="60"
            ></v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <p class="mb-0">
        By clicking <b class="teal--text darken-2">Confirm</b>, a deposit transaction of 
          <b>10500 F CFA</b> will be triggered through 
          <b v-if="paymentMethod">{{ paymentMethod === 'MTN' ? 'MTN Mobile Money' : 'Orange Money' }}</b>
          <b v-else class="red--text">[ select payment method]</b>
          from the phone number <b>{{ transactionPhoneNumber }}</b>
          <b v-if="!transactionPhoneNumber" class="red--text">[phone number]</b>
        </p>

      <div v-if="paymentMethod" class="mt-3">
        <p class="mb-0">If you are facing difficulties, send manually through the code below:</p>
        <p class="pl-2 mb-0 pt-1 red--text">
          - <b>{{ ussdCode }}</b>
          <v-btn 
            icon 
            @click="copyUSSD"
            class="ml-2"
            title="Copy USSD code"
          >
            <v-icon small>mdi-content-copy</v-icon>
          </v-btn>
        </p>
        
        <p class="pl-2 mb-0 pt-1" v-if="paymentMethod === 'MTN'">
          - Choose reference 1
        </p>
        <p class="pl-2 mb-0 pt-1" v-if="paymentMethod === 'OM'">
          - Input transaction amount
        </p>
        <p class="pl-2 mb-0 pt-1">
          - Always <b class="teal--text darken-2">Confirm</b> below
        </p>


      </div>
    </v-card-text>

<v-card-actions class="px-3"> 
  <v-btn color="teal" text @click="showPayment = false">Cancel</v-btn> 
  <v-spacer></v-spacer> 
  <v-btn 
  color="teal darken-2" 
  class="white--text" 
  @click="handlePaymentConfirmation"
  :disabled="!paymentMethod || !transactionPhoneNumber"
  :loading="processingPayment"
>
  Confirm
</v-btn>
</v-card-actions>
  </v-card> 
</v-dialog>
  </div>

  </div>
</template>

<script>
import axios from 'axios';
import referralMixin from '@/mixins/referralMixin';
import ReferralField from '@/components/ReferralField.vue';

export default {
  mixins: [referralMixin],
  components: { ReferralField },
  data() {
    return {
      showCreateAccountOptions: false,
      e1: true,
      transactionPhoneInput: null,
      fullnames_help: false,
      username_help: false,
      email_help: false,
      telephone_help: false,
      password_help: false,
      reference_help: false,
      phone_number_help: false,
      form: {
        name: '',
        username: '',
        telephone: '',
        password: '',
        email: '',
      },
      showPayment: false,
      paymentMethod: '',
      transactionPhoneNumber: '',
      transactionId: '',
      ussdCode: '',
      ussdCode2: '',
      hrefTel: '',
      phone_number: "Enter Phone Number",
      alert_message: "",
      phoneInput: [],
      transfer_code : '',
      
      processingPayment: false,
      usernameRules: [
        v => !!v || 'Username is required',
        v => (v && v.length >= 4) || 'Username must be at least 4 characters',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be at least 8 characters',
      ],
      emailRules: [
        v => !!v || 'Email is required',
        v => /.+@.+\..+/.test(v) || 'Email must be valid',
      ],
      phoneRules: [
        v => !!v || 'Phone number is required',
        v => /^[0-9]{9}$/.test(v) || 'Phone number must be 9 digits',
      ],
      
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    referralHint() {
      return this.$route.query.referral 
        ? 'Referral code from invitation link'
        : 'Default business referral code';
    }
  },
  mounted() {
this.initialiseIntel()
this.$store.commit('setSaveItem', "");
this.getUserInfo();
},
watch: {
    showPayment(newVal) {
      if (newVal) {
        this.$nextTick(() => this.initialiseTransactionIntel());
      }
    },
  },

  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    initialiseIntel(){
                function getIp(callback) {
                    fetch('https://ipinfo.io/json?token=fa5e74d3e65812', { headers: { 'Accept': 'application/json' }})
                    .then((resp) => resp.json())
                    .catch(() => {
                        return {
                            country: 'cm',
                        };
                    })
                    .then((resp) => callback(resp.country));
                }

                const phoneInputField = document.querySelector("#phone");
                this.phoneInput = window.intlTelInput(phoneInputField, {
                    initialCountry: "cm",
                    geoIpLookup: getIp,
                    preferredCountries: ["cm", "us", "uk", "ci", "cg", "cf", "td", "ng", "gq", "ga"],
                    utilsScript:
                    "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
                });
            },
            clearPhoneField(){
                let phone_number = this.phoneInput.getNumber()
                console.log(phone_number)
                if(phone_number === "Enter Phone Number"){
                    this.phone_number = ""
                }

            },
            initialiseTransactionIntel() {
      const transactionPhoneInputField = document.querySelector("#transactionPhone");
      this.transactionPhoneInput = window.intlTelInput(transactionPhoneInputField, {
        initialCountry: "cm",
        geoIpLookup: this.getIp,
        preferredCountries: ["cm", "us", "uk", "ci", "cg", "cf", "td", "ng", "gq", "ga"],
        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
      });

      transactionPhoneInputField.addEventListener('input', () => {
        this.transactionPhoneNumber = this.transactionPhoneInput.getNumber();
      });
    },

    clearTransactionPhoneField() {
      if (this.transactionPhoneInput?.getNumber() === "Enter Phone Number") {
        this.transactionPhoneInput.setNumber("");
      }
    },
            getSignUpFieldHelp(){
                if (this.fullnames_help){
                    this.fullnames_help = false
                    this.$store.commit('setDialogTitle', "Full Names")
                    this.$store.commit('setDialogMessage', "Here you are required to input all your names.")
                    this.$store.commit('activateDialog', true)
                }else if (this.username_help){
                    this.username_help = false
                    this.$store.commit('setDialogTitle', "Your User Name")
                    this.$store.commit('setDialogMessage', "Here you are required to input your User Name.")
                    this.$store.commit('activateDialog', true)
                }else if (this.password_help){
                    this.password_help = false
                    this.$store.commit('setDialogTitle', "Your Password")
                    this.$store.commit('setDialogMessage', "You are required to input your account password. This password needs to be at least 8 characters long. It is also advisable for you to write down this password so in case u forget, you can know where to get it.")
                    this.$store.commit('activateDialog', true)
                }else if (this.email_help ){
                    this.email_help = false
                    this.$store.commit('setDialogTitle', "why have an email")
                    this.$store.commit('setDialogMessage', "Your email will allow us to send you information and notifications regarding your business suite.")
                    this.$store.commit('activateDialog', true)
                }else if (this.phone_number_help){
                    this.phone_number_help = false
                    this.$store.commit('setDialogTitle', "Your Phone Number")
                    this.$store.commit('setDialogMessage', "Please input your phone number. This number will be used in sending of money and validating transactions. so make sure it is the right number.")
                    this.$store.commit('activateDialog', true)
                }else if (this.reference_help){
                    this.reference_help = false
                    this.$store.commit('setDialogTitle', "Who Refered You")
                    this.$store.commit('setDialogMessage', "This allows you to sponsor another user once you have a business suite you can place yours there.")
                    this.$store.commit('activateDialog', true)
                }
            },
            async getUserInfo() {
              if (this.$store.state.isAuthenticated) {
        axios
          .get('/api/v1/home/get/user/info/')
          .then(response => {
            this.$store.commit('setUser', response.data[0]["user"])
            this.$store.commit('setUserState', response.data[0]["user_info"])
            this.$store.commit('setUserInfo', response.data[0])
            this.$store.commit('setUserName', response.data[0]["user"]["username"])

            // Pre-fill form fields
            this.form.username = response.data[0].user.username;
            this.form.email = response.data[0].user.email;
            
            // Pre-fill phone number
            const phoneNumber = response.data[0].user_profile.phone_number;
            this.phone_number = phoneNumber;
            if (this.phoneInput) {
              this.phoneInput.setNumber(phoneNumber);
            }
          })
          .catch(error => {
                            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        })
                }
            },
   
            async submitForm() {
 

  
 if (this.form.username.length < 4) {
   this.$store.commit('setSnackBarMessage', "Username is too short, needs to be at least 4 characters");
   this.$store.commit('setSnackBarColor', "red darken-4");
   this.$store.commit('activateSnackBar', true);
   return;
 }
 
 if (this.form.password.length < 8) {
   this.$store.commit('setSnackBarMessage', "Password is too short, needs to be at least 8 characters");
   this.$store.commit('setSnackBarColor', "red darken-4");
   this.$store.commit('activateSnackBar', true);
   return;
 }
 if (!this.form.email) {
   this.$store.commit('setSnackBarMessage', "Email is required");
   this.$store.commit('setSnackBarColor', "red darken-4");
   this.$store.commit('activateSnackBar', true);
   return;
 }

 if (!/.+@.+\..+/.test(this.form.email)) {
   this.$store.commit('setSnackBarMessage', "Email must be valid");
   this.$store.commit('setSnackBarColor', "red darken-4");
   this.$store.commit('activateSnackBar', true);
   return;
 }
 if (!this.phoneInput.isValidNumber()) {
   this.$store.commit('setSnackBarMessage', "Phone number is invalid. Please input a valid number");
   this.$store.commit('setSnackBarColor', "red darken-4");
   this.$store.commit('activateSnackBar', true);
   return;
 }

 
 this.showPayment = true;

 this.$store.commit('setSnackBarMessage', 'Please enter your transaction number and select the payment method between Orange Money or MTN Momo.');
 this.$store.commit('setSnackBarColor', "teal darken-2");
 this.$store.commit('activateSnackBar', true);
 this.paymentMethod = '';
 this.ussdCode = '';
 this.transactionId = '';
 this.transactionPhoneNumber = '';
},
 


    selectOperator(operator) {
      this.paymentMethod = operator;
      this.generateUSSD();
      this.transactionId = this.generateTransactionId();
      this.showSnackbar(`Selected payment method: ${operator === 'MTN' ? 'MTN Mobile Money' : 'Orange Money'}`, 'info');
    },

    generateTransactionId() {
      const timestamp = Date.now();
      const random = Math.floor(Math.random() * 1000);
      return `${this.paymentMethod}-${timestamp}-${random}`;
    },
    generateUSSD() {
  const amount = 10500; 


  if (this.paymentMethod === "MTN") {
    this.ussdCode = `*126*4*${this.$store.state.MerchantCodeMTN}*${amount}#`;
    this.transfer_code = `*126*4*${this.$store.state.MerchantCodeMTN}*${amount}%23`;
    this.hrefTel = `tel:*126*4*${this.$store.state.MerchantCodeMTN}*${amount}%23`;
  } else if (this.paymentMethod === "OM") {
    this.transfer_code = `%23150*47*${this.$store.state.MerchantCodeOrange}*${amount}%23`;
    this.ussdCode = `#150*47*${this.$store.state.MerchantCodeOrange}*${amount}#`;
    this.hrefTel = `tel:%23150*47*${this.$store.state.MerchantCodeOrange}*${amount}%23`;
  }


  

  const dialLink = document.getElementById('dial_transaction');
  if (dialLink) {
    dialLink.setAttribute('href', this.hrefTel);
    dialLink.setAttribute('target', '_blank');
  }
},
async handlePayment() {
  if (!this.transactionPhoneNumber) {
    this.showSnackbar('Please enter payment phone number', 'error');
    this.$store.commit("Please enter payment phone number");
    this.$store.commit('setSnackBarColor', "red darken-4");
    this.$store.commit('activateSnackBar', true);
    return;
  }

  if (!this.paymentMethod) {
    this.showSnackbar('Please select payment operator', 'error');
    this.$store.commit("Please select payment operator");
    this.$store.commit('setSnackBarColor', "red darken-4");
    this.$store.commit('activateSnackBar', true);
    return;
  }

  if (!this.transactionPhoneNumber.match(/^[0-9]{9}$/)) {
    this.showSnackbar('Invalid phone number format (9 digits required)', 'error');
    this.$store.commit("Invalid phone number format (9 digits required)");
    this.$store.commit('setSnackBarColor', "red darken-4");
    this.$store.commit('activateSnackBar', true);

    return;
  }
 
  try {
    this.generateUSSD();
    this.showSnackbar('Payment interface opening...', 'info');
    
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      window.location.href = this.hrefTel;
    } else {
      const win = window.open('', '_blank');
      win.location = this.hrefTel;
    }
    
    
    // Générer l'ID de transaction
    this.transactionId = this.generateTransactionId();

    
  } catch (error) {
    this.showSnackbar('Payment initiation failed: ' + error.message, 'error');
  }
},
async handlePaymentConfirmation() {
      if (!this.paymentMethod) {
        this.showSnackbar('Please select payment operator', 'error');
        return;
      }
      if (!this.transactionPhoneInput?.isValidNumber()) {
    this.$store.commit('setSnackBarMessage', "Phone number is invalid. Please input a valid number");
    this.$store.commit('setSnackBarColor', "red darken-4");
    this.$store.commit('activateSnackBar', true);
        return;
      }
      
      try {
        this.generateUSSD();
        window.location.href = this.hrefTel;
    
    
    await this.confirmPayment();

   
    setTimeout(() => {
      if (!document.hidden) {
        window.open(this.hrefTel, '_blank');
      }
    }, 200);

      } catch (error) {
        this.showSnackbar(error.message, 'error');
      }
    },

    validatePaymentDetails() {
      if (!this.paymentMethod) {
        throw new Error('Please select a payment operator');
      }
      
      if (!this.transactionPhoneNumber?.match(/^[0-9]{9}$/)) {
        throw new Error('Invalid phone number (9 digits required)');
      }
      return true;
    },

    openPaymentInterface() {
      try {
        const opener = this.isMobile ? window.location.href = this.hrefTel : window.open(this.hrefTel, '_blank');
        this.showSnackbar('Payment interface opening...', 'info');
        return opener;
      } catch (error) {
        throw new Error('Failed to open payment interface');
      }
    },
    async confirmPayment() {
      this.processingPayment = true;
      
      try {
        const response = await axios.post('/api/v1/savings/business-account/', this.createPayload());
        
        if (!response.data.success) {
          this.$store.commit('setSnackBarMessage', "Please check your password and username are the same as the ones used in your PettyCash account....");
          this.$store.commit('setSnackBarColor', "teal darken-2");
          this.$store.commit('activateSnackBar', true);
        }
        
        await this.handleSuccessFlow(response);
      } catch (error) {
        this.handleApiError(error);
        throw error;
      } finally {
        this.processingPayment = false;
      }
    },

    createPayload() {
      return {
       
        fullnames: this.form.name,
        username: this.form.username,
        password: this.form.password,
        phone_number: this.phoneInput.getNumber(),
        payment_method: this.paymentMethod,
        email: this.form.email,
        transaction_id: this.transactionId,
        transaction_phone: this.transactionPhoneInput.getNumber(),
        serial_no: this.getReferralPayload()
      };
    },
    watch: {
    showPayment(newVal) {
      if (newVal) {
        this.$nextTick(() => this.initialiseTransactionIntel());
      }
    },
  },

    async handleSuccessFlow(_response) {
      this.showSuccessMessage();
      await this.handleAutoLogin();
      this.redirectToCampaign();
    },

    showSuccessMessage() {
      this.$store.commit('setSnackBarMessage', "🎉 Your account has been successfully created! You will receive a confirmation email after verification. Redirecting...");
      this.$store.commit('setSnackBarColor', "teal darken-2");
      this.$store.commit('activateSnackBar', true);
    },

    async handleAutoLogin() {
      try {
        const { data } = await axios.post('/api/v1/token/login/', {
          username: this.form.username,
          password: this.form.password
        });
        
        this.$store.commit('setToken', data.auth_token);
        axios.defaults.headers.common['Authorization'] = "Token " + data.auth_token;
        localStorage.setItem('token', data.auth_token);
      } catch (error) {
        this.handleLoginError(error);
        throw new Error('Auto-login failed');
      }
    },

    redirectToCampaign() {
      setTimeout(() => {
        this.$router.push({
          path: '/All',
          query: {
            username: this.form.username,
            password: this.form.password
          }
        });
        this.resetForm();
        this.showPayment = false;
      }, 6000);
    },

    handleLoginError(error) {
      if (error.response) {
        const errors = error.response.data;
        for (const property in errors) {
          this.showSnackbar(errors[property][0], 'error');
        }
      } else {
        this.showSnackbar("An error occurred while logging in", 'error');
      }
    },

    copyUSSD() {
      navigator.clipboard.writeText(this.ussdCode);
      this.showSnackbar('USSD code copied to clipboard!', 'success');
    },

    resetForm() {
      this.form = {
        name: '',
        username: '',
        telephone: '',
        email: '',
        affiliate_referral: '',
      };
      this.transactionPhoneNumber = '';
    },

    showSnackbar(message, type) {
      this.$store.dispatch('showSnackbar', {
        message,
        color: type === 'error' ? 'red' : 'green',
        timeout: 3000
      });
    },

    handleApiError(error) {
      const message = error.response?.data?.error || 'An error occurred';
      this.showSnackbar(message, 'error');
      console.error('API Error:', error.response?.data || error.message);
    },
    async getOurTeamInfo() {
      this.$store.commit("setIsLoading", true);
      try {
        const response = await axios.get("/api/v1/home/get/our_team/info/");
        this.team_members = response.data;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.$store.commit("setIsLoading", false);
      }
    },

    async checkPaymentStatus() {
      if (!this.$store.state.isAuthenticated) return;
      
      try {
        const response = await axios.get('/api/v1/home/payment-status/');
        this.userPaymentStatus = response.data.payment_status;
        

      } catch (error) {
        console.error('Erreur de statut de paiement:', error);
        this.showError("Impossible de vérifier le statut de paiement");
      }
    },

    handleCreateAccountClick() {
      this.showCreateAccountOptions = true;
    },

    handleError(error) {
      const message = error.response 
        ? `${error.response.status} - ${error.response.statusText}`
        : "Erreur réseau - Vérifiez votre connexion Internet";

      this.$store.commit("setSnackBarMessage", message);
      this.$store.commit("setSnackBarColor", "red darken-4");
      this.$store.commit("activateSnackBar", true);
    }
  }
};
</script>

<style scoped>
.selected-operator {
  border: 2px solid #009688 !important;
  background-color: #e0f2f1 !important;
}

.operator-card {
  cursor: pointer;
  transition: transform 0.3s ease;
  border: 2px solid transparent;
}

.operator-card:hover {
  transform: scale(1.05);
}

.instruction-list div {
  display: flex;
  align-items: center;
  margin: 8px 0;
  font-size: 0.9rem;
}

.v-alert--info {
  background-color: #e3f2fd !important;
  border-left: 4px solid #2196F3;
}

.v-text-field--readonly .v-input__slot {
  background-color: #f5f5f5 !important;
}

a[href^="tel:"] {
  color: inherit;
  text-decoration: none;
  font-family: monospace;
}

@media (max-width: 600px) {
  .v-dialog {
    margin: 0 !important;
    border-radius: 0 !important;
  }
  
  .v-card__title {
    font-size: 1.1rem !important;
    padding: 12px !important;
  }
  
  .operator-card {
    margin: 5px !important;
  }
}
/* Ajouter dans les styles */
.v-snack__wrapper {
  max-width: 400px !important;
  word-break: break-word;
}

.payment-redirect-message {
  background-color: #e3f2fd !important;
  border-left: 4px solid #2196F3;
  padding: 15px;
  margin-bottom: 20px;
  border-radius: 4px;
}

/* Ajouter dans les styles */
.phone-button {
  transition: all 0.3s ease;
}

.phone-button:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}

.fa-phone {
  font-size: 1.2em;
}
.v-input--is-disabled .v-label {
  color: rgba(0, 0, 0, 0.6) !important;
}
.v-input__append-inner {
  padding-left: 8px;
}

.optional-field {
  border-left: 3px solid teal;
  padding-left: 8px;
  margin: 10px 0;
}  .masked-password input {
  -webkit-text-security: disc; /* Masque les caractères pour WebKit */
  text-security: disc; /* Standard futur */
}


/* Solution de repli pour Firefox */
@-moz-document url-prefix() {
  .masked-password input[type="text"] {
    font-family: monospace !important;
    font-size: 0.8em !important;
    letter-spacing: 0.2em;
  }
}

.signup-wrapper {
  background: #f0f2f5;
  min-height: 100vh;
  padding: 72px 0 112px;
}

.form-container {
  max-width: 432px;
  margin: 0 auto;
}

.signup-card {
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header {
  text-align: center;
  margin-bottom: 24px;
}

.pettycash-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 3.5rem;
  font-weight: 700;
  letter-spacing: -0.5px;
}

/* Conserver la couleur verte pour "Cash" */
.pettycash-logo div:last-child {
  color: teal;
}

.subtitle {
  color: #1c1e21;
  font-size: 1.6rem;
  font-weight: 400;
  margin-bottom: 16px;
}

.divider {
  border-bottom: 1px solid #dadde1;
  margin: 16px 0;
}

.custom-field {
  margin-bottom: 12px;
}

.custom-field::v-deep .v-label {
  font-size: 0.880rem;
  color: #606770;
}

.signup-btn {
  margin: 16px 0;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0.25px;
  height: 48px !important;
}

.login-link {
  text-align: center;
  color: #1c1e21;
  font-size: 0.875rem;
  padding-top: 16px;
  border-top: 1px solid #dadde1;
  margin-top: 16px;
}

.login-link a {
  color: teal;
  font-weight: 600;
  text-decoration: none;
}

.login-link a:hover {
  text-decoration: underline;
}

/* Responsive */
@media (max-width: 600px) {
  .form-container {
    padding: 0 16px;
  }
  
  .signup-card {
    box-shadow: none;
    background: transparent;
  }
}
</style>